import React, { Component } from 'react';
import './contactUs.css';
import Topnavbar from '../components/topnavbar';
import Bottomnavbar from '../components/bottomnavbar';
import FooterNavbar from '../components/footerNavbar';
import Footer from '../components/footer';

export default class ContactUs extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Topnavbar />
        <Bottomnavbar />

        <div className="container">
          <section
            className="section1 wow fadeIn"
            data-wow-duration="1s"
            data-wow-delay="0.2s"
          >
            <div className="content p-5 col-md-10 offset-md-1 border-right border-bottom">
              <div className="row">
                <div className="col-md-4 p-3">
                  <h4 className="h4ServHistory">
                    <strong>Contact Us</strong>
                  </h4>
                </div>

                <div className="col-md-8  p-4 border-left">
                  <p className="midnightBlue contactBig">Customer services</p>
                  <p className="midnightBlue">
                    <small>Any questions? Call us on:</small>
                  </p>

                  <p className="midnightBlue contactBig">
                    <a href="tel:0800981981">
                      <strong>0800 981 981</strong>
                    </a>
                  </p>
                  <p />
                  <p className="midnightBlue mb-0">
                    <small>
                      <strong>Opening hours:</strong>
                    </small>
                  </p>
                  <table className="midnightBlue">
                    <tbody>
                      <tr>
                        <td>
                          <small>Mon to Fri:</small>
                        </td>
                        <td>
                          <small>&nbsp; 9:00 to 18:00</small>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <small>Sat:</small>
                        </td>
                        <td>
                          <small>&nbsp; 9:00 to 13:00</small>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <p />
                  <p className="midnightBlue ">
                    <small>
                      <strong>Or email:</strong>
                      <br />
                      {/* <span className="contactBig"> */}
                      <span>
                        <a href="mailto:customer.query@hyundai.co.uk">
                          customer.query@hyundai.co.uk
                        </a>
                      </span>
                    </small>
                  </p>
                  <p />
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* <div className="row m-4" >
                    <div className="col text-center">
                    <a className="btn btn-link" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                    <i className="far fa-arrow-alt-circle-down"></i>
  </a>
                    </div>
                </div>   */}

        {/* <div className="collapse" id="collapseExample"> */}
        <FooterNavbar />

        {/* <div className="container p-3"><div className="row"><div className="col-md-2"><ul className="bottomNavList pt-3"><small><li className="pb-1"><strong>My Car</strong></li></small><a href="#"><small><li className="pb-1">My Vehicle</li></small></a><a href="#"><small><li className="pb-1">Service History</li></small></a><a href="#"><small><li className="pb-1">My Reminders</li></small></a><a href="#"><small><li className="pb-1">Finance Details</li></small></a><a href="#"><small><li className="pb-1">"How To" Guide</li></small></a><a href="#"><small><li className="pb-1">My Vehicle</li></small></a><a href="#"><small><li className="pb-1">My Vehicle</li></small></a></ul></div><div className="col-md-2"><ul className="bottomNavList pt-3"><small><li className="pb-1"><strong>News</strong></li></small><a href="#"><small><li className="pb-1">Brand News</li></small></a><a href="#"><small><li className="pb-1">Service History</li></small></a><a href="#"><small><li className="pb-1">What's Happening Now</li></small></a><a href="#"><small><li className="pb-1">Product News</li></small></a></ul></div><div className="col-md-2"><ul className="bottomNavList pt-3"><small><li className="pb-1"><strong>My Profile</strong></li></small><a href="#"><small><li className="pb-1">Personal Details</li></small></a><a href="#"><small><li className="pb-1">Preferences</li></small></a><a href="#"><small><li className="pb-1">Interests</li></small></a><a href="#"><small><li className="pb-1">Dealer Details</li></small></a></ul></div><div className="col-md-2"><ul className="bottomNavList pt-3"><small><li className="pb-1"><strong>Request History</strong></li></small><a href="#"><small><li className="pb-1">Quote Requests</li></small></a><a href="#"><small><li className="pb-1">Test Drive</li></small></a><a href="#"><small><li className="pb-1">Brochures</li></small></a><a href="#"><small><li className="pb-1">Car Configuration</li></small></a></ul></div><div className="col-md-2"><ul className="bottomNavList pt-3"><small><li className="pb-1"><strong>Competitions</strong></li></small></ul></div><div className="col-md-2"><ul className="bottomNavList pt-3"><small><li className="pb-1"><strong>My Rewards</strong></li></small></ul></div></div></div> */}

        {/* </div> */}

        <Footer />
      </div>
    );
  }
}
